module.exports = __webpack_public_path__ + "static/full15-dc8b345785095b3d9a585cb38b00f6e7.png";